module.exports = __webpack_public_path__ + "img/img63.fe9ff7c2.png";